import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaSessions } from 'src/apps/mfa/services/MfaDashboardService';
import { TMfaSessionsResult } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { MFA_SESSIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';
import { IUseTableQueryParams } from 'src/common/types/UseTableQueryParamsType';

export const useMfaSessionsQuery = ({
	filters,
	sort,
	page,
	pageSize
}: IUseTableQueryParams): UseQueryResult<TMfaSessionsResult> => {
	return useQuery(
		[MFA_SESSIONS, filters, sort, page, pageSize],
		async (): Promise<TMfaSessionsResult> =>
			getMfaSessions({
				filterOptions: filters as ITableQueryParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			keepPreviousData: true
		}
	);
};
